import * as ActionTypes from './actionType';

/*
* 解析任务相关
* */

export const setCurrent = (error) => ({
    type: ActionTypes.SET_QUESTION_EXPLAIN_CURRENT,
    payload: error
});


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/action.js